module.exports = __webpack_public_path__ + "img/bg-bg-new-main-top.c2ebd593.svg";